export default __webpack_public_path__ + "static/AdKuuCreator-01edf953984437a8104f643e6c44ab60.mp4";